var _defs, _polygon, _path, _animate;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnimatedLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 450 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "dropshadow",
    height: "130%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "bluranim",
    in: "SourceGraphic",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.5
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "425 361.33 226.38 475 26.39 363.67 25 138.67 223.62 25 423.62 136.33 425 361.33",
    filter: "url(#dropshadow)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.48,5.72l220,120.94L445,370.79,226.52,494.28,6.54,373.34,5,129.21,223.48,5.72m0-5.72L0,126.3l1.56,250,225,123.7L450,373.7l-1.56-250L223.44,0Z",
    filter: "url(#dropshadow)"
  })), _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    xlinkHref: "#bluranim",
    attributeName: "stdDeviation",
    values: "7;20;7",
    dur: "6s",
    repeatCount: "indefinite"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatedLogo);
export default __webpack_public_path__ + "static/media/animated-logo.b3b54b1f.svg";
export { ForwardRef as ReactComponent };